import React, { Component } from 'react'
import { observer } from 'mobx-react'
import styled from 'styled-components'
import { Links } from './links'
import RTLWrapper from 'src/common/rtl/RTLWrapper'

export const FOOTER_HEIGHT = 39

@observer
class FooterLinks extends Component {
  ref = null

  componentDidMount() {
    this.getHeightOfFooter()
  }

  getHeightOfFooter() {
    const { updatePadding } = this.props
    if (typeof updatePadding === 'function') {
      this.ref ? updatePadding(this.ref.clientHeight) : updatePadding()
    }
  }

  render() {
    const { links, appStyles } = this.props
    return links && links.length > 0 ? (
      <Inner className="px-sparq-footer" role="contentinfo" ref={(r) => (this.ref = r)}>
        <RTLWrapper>
          <Links links={links} appStyles={appStyles} isPartOfFooter={false} />
        </RTLWrapper>
      </Inner>
    ) : null
  }
}

const Inner = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  display: block;
  background-color: #fff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.3);
  z-index: 1002;
`

export default FooterLinks
